import { LinearGradient } from 'expo-linear-gradient';
import React from 'react';
import { StyleSheet, ViewStyle } from 'react-native';

import { iqesColors } from '../../shared/ui/iqesDesignSystem';
import { colors } from '../tokens';

type GradientPreset = 'primary' | 'accent' | 'correct' | 'surface';

interface DSGradientBackgroundProps {
  preset?: GradientPreset;
  customColors?: readonly [string, string, ...string[]];
  style?: ViewStyle;
  children: React.ReactNode;
}

const presetColors: Record<GradientPreset, readonly string[]> = {
  primary: colors.gradientPrimary,
  accent: colors.gradientAccent,
  correct: colors.gradientCorrect,
  surface: [iqesColors.canvas, iqesColors.navy, '#12081F'] as const,
};

export const DSGradientBackground: React.FC<DSGradientBackgroundProps> = ({
  preset = 'surface',
  customColors,
  style,
  children,
}) => {
  const gradientColors = customColors || presetColors[preset];

  return (
    <LinearGradient
      colors={gradientColors as [string, string, ...string[]]}
      start={{ x: 0, y: 0 }}
      end={{ x: 0, y: 1 }}
      style={[styles.container, style]}
    >
      {children}
    </LinearGradient>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
});
